var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"SlcSelectionControls-addButton ma-0 ml-4",attrs:{"color":"primary","loading":_vm.fetching,"disabled":_vm.fetching,"small":""},on:{"click":function($event){$event.stopPropagation();_vm.addToList();
    _vm.onAddClick();}}},[_vm._v("\n  "+_vm._s(_vm.$t("addToOpenList"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }